import classNames from 'classnames';
import uniqueId from 'lodash/uniqueId';
import * as React from 'react';
import type { Facet } from '../../../Search/Facet.csharp';
import type { SelectedFacet } from '../../../Search/SelectedFacet.csharp';
import { useFrontendSettings } from '~/Features/Configuration/Hooks/useFrontendSettings';

interface FacetProps {
    facet: Facet;
    selectedFacets: SelectedFacet[];
    onChange: (newFacets: SelectedFacet[]) => void;
}

export const FacetItem: React.FunctionComponent<React.PropsWithChildren<FacetProps>> = ({
    facet,
    selectedFacets,
    onChange,
}) => {
    const { checkboxVariant } = useFrontendSettings();

    const selectedFacet = selectedFacets.find(sf => sf.id === facet.id);
    const { id, options } = facet;

    const updateSelectedFacetValue = (facetId: string, facetOption: { value: string; isChecked: boolean }) =>
        selectedFacets.map((sf: SelectedFacet) => {
            if (sf.id === facetId) {
                return { ...sf, values: updateFilterValues(sf, facetOption) };
            }

            return sf;
        });

    const updateFilterValues = (
        selectedFacetToUpdate: SelectedFacet,
        facetOption: { value: string; isChecked: boolean }
    ) => {
        const selectedFacetValues = selectedFacetToUpdate.values;

        if (facetOption.isChecked) {
            return [...selectedFacetValues, facetOption.value];
        }

        return selectedFacetValues.filter(item => item !== facetOption.value);
    };

    const handleOnChange = (facetOption: { value: string; isChecked: boolean }) => {
        const updatedSelectedFacet = updateSelectedFacetValue(id, facetOption);
        onChange(updatedSelectedFacet);
    };

    return (
        <>
            {!!options.length && (
                <ul className="Form__list">
                    {options.map(value => {
                        const uniqueFacetId = uniqueId('FacetItem__');

                        return (
                            <li key={uniqueFacetId}>
                                <div className={classNames('Form__checkbox', `Variant--${checkboxVariant}`)}>
                                    <input
                                        type="checkbox"
                                        value={value.id}
                                        id={uniqueFacetId}
                                        checked={selectedFacet && selectedFacet.values.some(v => v === value.id)}
                                        onChange={e =>
                                            handleOnChange({
                                                value: e.target.value,
                                                isChecked: e.target.checked,
                                            })
                                        }
                                    />
                                    <label htmlFor={uniqueFacetId}>{value.label}</label>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            )}
        </>
    );
};
